
export default [{
    path: '/exports-data',
    component: () => import('./views/ExportsData.vue'),
    meta: {
        requiresAuth: true,
    },
    children: [
        {
            path: '',
            name: 'exports-data',
            component: () => import('./views/ExportsDataList.vue'),
        },
    ]
},];